module.exports = __webpack_public_path__ + "img/top1.584296fb.png";